import ResultBase from '../ResultBase'
import styles from './ValuesList.module.css'
import globalStyles from '../../../styles/resultValues.module.css'
import { FC } from 'react'
import { ResultType } from '../../../types/Result'
import { Option } from '../../../types/Exercise'
import { Translatable } from '../../../common/types/translatable'
import { getDetectedLanguage } from '../../../i18n'

interface StepData {
  options: Translatable<Option[]>
}

interface ValuesListProps {
  header: string
  response: number | number[] | string | string[]
  stepData: StepData
  type: ResultType.MULTIPLE_CHOICE | ResultType.SCALE
}

const ValuesList: FC<ValuesListProps> = ({ header, response, stepData }) => {
  if (response instanceof Array) {
    const listStyle =
      response.length > 1 ? styles.listContainer : styles.valueContainer

    const optionStyle = response.length > 1 ? styles.listItem : styles.item

    return (
      <ResultBase title={header}>
        <div className={`${globalStyles.valueContainer} ${listStyle}`}>
          {response.map((value, index) => {
            return (
              <div
                className={`${globalStyles.value} ${optionStyle}`}
                key={index}
              >
                {value}
              </div>
            )
          })}
        </div>
      </ResultBase>
    )
  } else {
    return (
      <ResultBase title={header}>
        <div
          className={`${globalStyles.valueContainer} ${styles.valueContainer}`}
        >
          <div className={`${globalStyles.value} ${styles.item}`}>
            {stepData.options.de.length > 2
              ? stepData.options[getDetectedLanguage()].at(response as number)
                  ?.option
              : response}
          </div>
        </div>
      </ResultBase>
    )
  }
}

export default ValuesList
